<script setup>
defineEmits(['openTermsOfService', 'openAiPolicy'])
</script>

<template>
  <footer
    class="bradley-legal-disclaimer-bar"
    role="contentinfo"
  >
    <div class="bradley-legal-disclaimer-bar__inner flex flex-col gap-0">
      <p class="bradley-legal-disclaimer-bar__note m-0 flex flex-wrap items-center justify-center gap-2 text-center font-inter text-xs font-normal leading-4 text-[#7A7A93]">
        <i
          class="pi pi-info-circle shrink-0 text-[13px] leading-none text-[#7A7A93]"
          aria-hidden="true"
        />
        <span>{{ $t('newBradley.input.disclaimerNote') }}</span>
      </p>
      <i18n-t
        keypath="newBradley.input.disclaimerLinks"
        tag="p"
        class="bradley-legal-disclaimer-bar__links m-0 text-center font-inter text-xs font-normal leading-4 text-[#7A7A93]"
      >
        <template #terms>
          <a
            href="#"
            class="font-semibold text-[#7A7A93] underline underline-offset-2 decoration-solid hover:text-dss-primary-600"
            @click.prevent="$emit('openTermsOfService')"
          >{{ $t('newBradley.input.termsOfService') }}</a>
        </template>
        <template #policy>
          <a
            href="#"
            class="font-semibold text-[#7A7A93] underline underline-offset-2 decoration-solid hover:text-dss-primary-600"
            @click.prevent="$emit('openAiPolicy')"
          >{{ $t('newBradley.input.aiPolicy') }}</a>
        </template>
      </i18n-t>
    </div>
  </footer>
</template>

<style scoped>
.bradley-legal-disclaimer-bar {
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 1.5rem max(1rem, var(--bradley-layout-padding-left, 32px)) calc(1rem + env(safe-area-inset-bottom, 0))
    max(1rem, var(--bradley-layout-padding-right, 32px));
  margin-top: auto;
  background-color: transparent;
}

.bradley-legal-disclaimer-bar__inner {
  max-width: 42rem;
  margin-left: auto;
  margin-right: auto;
}

.bradley-legal-disclaimer-bar__links a {
  cursor: pointer;
}
</style>
